import React, { useState, useEffect } from 'react';
import './UpdateProjectForm.css';
import {Text, SwitchField} from '@aws-amplify/ui-react';
import { updateProject } from '../graphql/mutations';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

const FormComponent = ({selectProject, onCancel, onUpdate}) => {
  const [name, setName] = useState('');
  const [path, setPath] = useState('');
  const [metadata, setMetadata] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setName(selectProject.name);
    setPath(selectProject.path);
    setMetadata(selectProject.metadata);
  }, [selectProject.name, selectProject.path, selectProject.metadata]);

  const handlersOnCancel = () => {
    onCancel();
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic
    if (name === selectProject.name && path === selectProject.path && metadata === selectProject.metadata) {
        setError('No hay datos para actualizar');
        return;
    }
    try {
        const updatedProject = await client.graphql({
          query: updateProject,
          variables: {
            input: {
              id: selectProject.id,
              name: name,
              path: path,
              metadata: metadata
            }
          }
        });
  
        console.log("Project updated successfully");
        onUpdate(updatedProject.data.updateProject);
        return updatedProject;
      } catch (error) {
        console.error("Error updating project:", error);
        throw error;
      }
  };

  return (
    <>
        <Text color="#588292">ACTUALIZAR PROYECTO</Text>
        <br/>
      <form onSubmit={handleSubmit}>
        <label>
          Name*
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>
        <label>
          Path*
          <input
            type="text"
            value={path}
            onChange={(e) => setPath(e.target.value)}
            required
          />
        </label>
        <label className="metadata-label">
          Metadata
                    <SwitchField
            isChecked={metadata}
            labelPosition="start"
            onChange={(e) => setMetadata(e.target.checked)}
            />
        </label>   
        {error && <Text color="red">{error}</Text>}
        <div className="button-container">
          <button type="button" onClick={handlersOnCancel}>
            Cancelar
          </button>
          <button type="submit" onClick={handleSubmit}>
            Actualizar
          </button>
        </div>
      </form>
    </>
  );
};

export default FormComponent;
